import values from "../values";

import {ISchoolGrade} from "./../types/school.interface";

export function htmlToMongo(grade?: ISchoolGrade[]) {
  if (!grade) return undefined;
  return grade?.map((item: ISchoolGrade) => ({
    entranceTime: `1999-03-17T${item.entranceTime.hour ? item.entranceTime.hour : "00"}:${
      item.entranceTime.minute ? item.entranceTime.minute : "00"
    }:00.000Z`,
    departTime: `1999-03-17T${item.departTime.hour ? item.departTime.hour : "00"}:${
      item.departTime.minute ? item.departTime.minute : "00"
    }:00.000Z`,
    grade: item.grade?._id,
  }));
}

export function mangoToHtml(grade?: ISchoolGrade[] | undefined) {
  const undefinedResponse = {
    grade: undefined,
    departTime: {hour: "00", minute: "00"},
    entranceTime: {hour: "00", minute: "00"},
  };

  if (!grade) return undefinedResponse;
  const gradeArray = grade?.map((obj: any) => ({
    departTime: {
      hour: new Date(obj.departTime).getUTCHours().toString().padStart(2, "0"),
      minute: new Date(obj.departTime).getUTCMinutes().toString().padStart(2, "0"),
    },
    entranceTime: {
      hour: new Date(obj.entranceTime).getUTCHours().toString().padStart(2, "0"),
      minute: new Date(obj.entranceTime).getUTCMinutes().toString().padStart(2, "0"),
    },
    grade: values.dropdownItems.GRADE.find((item) => item._id === obj.grade),
  }));

  return gradeArray ? gradeArray : undefinedResponse;
}
